// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__vatyf","tcgland":"Sidebar_tcgland__6fpZx"};